import React from "react";
import {
  Heart,
  GraduationCap,
  MapPin,
  HelpingHand,
  BookOpen,
  Shield,
  Users,
  Leaf,
} from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
              নিঃস্বার্থ নবজীবন সংগঠন (NNS)
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            একটি অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন
          </p>
        </div>

        {/* Mission Statement */}
        <div className="card mb-10 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
          <div className="card-body p-6 md:p-8">
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              আমরা ভালবাসা, আশা এবং সামাজিক ন্যায়বিচার সমবেত একটি পৃথিবীর
              স্বপ্ন দেখি, যেখানে মানুষ মর্যাদা ও নিরাপত্তা নিয়ে বাস করবে।
              সমাজের অনগ্রসর শ্রেণীকে বিশেষভাবে চরম দরিদ্র, গৃহহীন ও অনাথ
              শিশুদেরকে শিক্ষা, পুষ্টি ও আশ্রয় সরবরাহের মাধ্যমে তাদের জাতির
              জন্য সম্পদে পরিণত করা আমাদের প্রধান লক্ষ্য।
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              ইহা সম্পূর্ণ অরাজনৈতিক, অলাভজনক, সামাজিক উন্নয়নমুলক, সাংস্কৃতিক ও
              সেচ্ছায় মানব সেবার সংগঠন। এই সংগঠন স্কুল/কলেজের ছাত্র, এলাকার
              তরুণ যুবক এবং বিভিন্ন শ্রেণীর সদস্য নিয়ে গঠিত এবং সর্ব শ্রেণীর
              উন্নয়নের জন্য কার্যক্রম পরিচালনা করছে।
            </p>
          </div>
        </div>

        {/* Additional Sections */}
        <div className="space-y-8">
          <div className="card shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <div className="card-body p-6 md:p-8">
              <div className="flex items-center mb-4">
                <BookOpen
                  className="h-6 w-6 text-purple-500 mr-2"
                  strokeWidth={2}
                />
                <h3 className="text-xl font-semibold text-gray-800">
                  শিক্ষা ও উন্নয়ন
                </h3>
              </div>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  এলাকার গরীব, অসহায় মেধাবী ছাত্র-ছাত্রীদের পড়া লেখা চালিয়ে
                  যেতে সহায়তা বা উদ্ভুদ্ব করা এবং বিনামুল্যে বই বিতরণ করা।
                </li>
                <li>
                  ছাত্র-ছাত্রীদের মেধা ও সৃজনশীলতার সর্বাধিক বিকাশের লক্ষ্যে
                  তাদেরকে প্রণোদিত ও সংগঠিত করা ও মেধাবী ছাত্র ছাত্রীদেরকে
                  উপবৃত্তি প্রদান করা।
                </li>
                <li>
                  শিশু কল্যাণ: এলাকার গরীব শিশু-কিশোরদের অক্ষরদান দেয়ার জন্য
                  গণশিক্ষা কেন্দ্র/পাঠাগার প্রতিষ্ঠা করা এবং দরিদ্র শিশুদের
                  খেলাধুলার পাশাপাশি সু-স্বাস্থ্য নিশ্চিত কল্পে ফ্রি চিকিৎসার
                  ব্যবস্থা করা এবং শিশুদের বাল্যবিবাহ রোধে সভা-সেমিনার ও
                  গণসচেতনতা সৃষ্টি করা।
                </li>
              </ul>
            </div>
          </div>

          <div className="card shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <div className="card-body p-6 md:p-8">
              <div className="flex items-center mb-4">
                <Shield
                  className="h-6 w-6 text-green-500 mr-2"
                  strokeWidth={2}
                />
                <h3 className="text-xl font-semibold text-gray-800">
                  সামাজিক সেবা
                </h3>
              </div>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  সমাজের সবার মধ্যে সামাজিক দায়বদ্ধতা বোধ সৃষ্টি করে সমাজ সচেতন
                  নাগরিক হিসেবে গড়ে তোলা।
                </li>
                <li>
                  দেশের দুর্ভিক্ষ, বন্যা, ঘুর্ণিঝড়, ভূমিকম্প, মহামারী,
                  অনাবৃষ্টি, অতিবৃষ্টি, সকল প্রকার প্রাকৃতিক দুর্যোগে সাহায্য
                  সামগ্রী নিয়ে দুঃস্থ ও ক্ষতিগ্রস্থদের পাশে এগিয়ে যাওয়া শীত
                  বস্ত্র বিতরণ এবং তহিবল বৃদ্ধি ও সংরক্ষণের্থে দান।
                </li>
              </ul>
            </div>
          </div>

          <div className="card shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <div className="card-body p-6 md:p-8">
              <div className="flex items-center mb-4">
                <Users
                  className="h-6 w-6 text-yellow-500 mr-2"
                  strokeWidth={2}
                />
                <h3 className="text-xl font-semibold text-gray-800">
                  সচেতনতা ও সংস্কৃতি
                </h3>
              </div>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>মাদক মুক্ত এলাকা গড়তে প্রশাসনকে সহযোগিতা করা।</li>
                <li>
                  এলাকার মাদকাসক্ত, জুয়াড়ি, বখাটে ও অপরাধীদের সুস্থ জীবনে
                  ফিরিয়ে আনার লক্ষে বিনোদন, গণসচেতনতা ও চিকিৎসার ব্যবস্থা করা
                  এবং কর্মসংস্থানের জন্য উৎসাহ প্রদান করা।
                </li>
                <li>
                  সমাজ বিরোধী কার্যকলাপ হইতে জনগণকে বিরত রাখিবার উদ্দেশ্যে
                  চিত্ত-বিনোদন ও সাংস্কৃতিক কর্মসূচীর ব্যবস্থা করা।
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact/Location Information */}
        <div className="divider my-10"></div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-inner">
          <div className="flex items-center justify-center">
            <MapPin className="h-5 w-5 text-gray-500 mr-2" strokeWidth={2} />
            <p className="text-gray-600 font-medium text-center">
              অস্থায়ী কার্যালয়ঃ খলিফা পট্টি, আন্দরকিল্লা, চট্টগ্রাম।
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
